import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ThorGameConfig} from "../../ThorGameConfig";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ThorReelBackgroundView} from "./ThorReelBackgroundView";

/**
 * Created by Jerker Nord on 2018-12-14.
 */

export class ThorReelBackgroundAreaView extends BaseView {

    public static readonly ADD_REEL_BACKGROUND:string = "ThorReelBackgroundAreaView_addReelBackground";
    public static thorReelBackgroundAreaView:ThorReelBackgroundAreaView;

    private _layer:ScalableLayer;

    constructor() {
        super();
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.REEL_BACKGROUND.name);
        this._layer.addChild(this);
        this.createMask();
        this.createBackground();
        ThorReelBackgroundAreaView.thorReelBackgroundAreaView = this;
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ThorReelBackgroundAreaView.ADD_REEL_BACKGROUND, (event:GameEvent) => this.onAddReel(event.params[0]));
    }

    private onAddReel(reelBackground:ThorReelBackgroundView):void {
        this.addChild(reelBackground);
    }

    private createBackground():void {
        const background = new PIXI.Graphics();
        background.beginFill(0x323e41, 1);

        const rect =  new PIXI.Rectangle(GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y, GameConfig.instance.REEL_AREA_WIDTH, GameConfig.instance.REEL_AREA_HEIGHT);
        background.drawRect(rect.x, rect.y, rect.width, rect.height);

        background.endFill();
        this.addChild(background);
    }

    private createMask():void {
        if(GameConfig.instance.REEL_AREA_MASK === false) {
            return;
        }
        const rect:PIXI.Rectangle = GameConfig.instance.REEL_AREA_MASK_RECT != undefined ? GameConfig.instance.REEL_AREA_MASK_RECT :
            new PIXI.Rectangle(GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y,
                GameConfig.instance.REEL_AREA_WIDTH, GameConfig.instance.REEL_AREA_HEIGHT);

        const maskShape = new PIXI.Graphics();
        maskShape.beginFill(0xFFFFFF, 1);
        maskShape.drawRect(rect.x, rect.y, rect.width, rect.height);
        maskShape.endFill();

        this.addChild(maskShape);
        this.mask = maskShape;
    }
}